import { useCallback } from 'react'
import { useMarkNotificationsAsReadMutation } from '../api'

export const useMarkNotificationsAsRead = () => {
  const [markAsReadMutation, { loading }] = useMarkNotificationsAsReadMutation()

  const markAsRead = useCallback(
    async (notificationIds: string[]) => {
      try {
        const result = await markAsReadMutation({
          variables: {
            notificationIds,
          },
        })

        return result.data?.notificationsMarkRead?.success ?? false
      } catch (error) {
        return false
      }
    },
    [markAsReadMutation]
  )

  return {
    markAsRead,
    loading,
  }
}
